import { Component, OnInit, ViewChild} from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import {  Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import { FiltrosCobranza } from '../../../models/FiltrosCobranza';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-cobranza',
  templateUrl: './listado-cobranza.component.html',
  styleUrls: ['./listado-cobranza.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoCobranzaComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Codigo = "E";
  pruebaMoneda: any;
  mySubscription: any;
  id_componente_padre: number[] = [13, 30, 33];
  ruc = new FormControl();
  rucAdq = new FormControl();

  estados = "R";
  idProv = 0;
  idAdq = 0;

  // Entradas de Busqueda
  RUC_PROV: string;
  RUC_ADQ: string;
  TipoMoneda: any = [];
  TipoBanco: any = [];
  TipoPago: any = [];
  Cobranza: any = [];

  dataPrueba: any;
  mensaje: any = [];
  TipoMonedaStorage: any = [];

  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  Estado: string = "";
  fechaDop: Date = new Date();
  fechaHop: Date = new Date();
  DTOFiltrosCobranza: FiltrosCobranza = new FiltrosCobranza();

  dataFiltro = new FormGroup({
    fromDate: new FormControl(''),
    toDate: new FormControl('')    ,
    Estado: new FormControl(''),
    Banco: new FormControl(0),
    Moneda: new FormControl(0),
    Tipo_Pago: new FormControl(0),
    provFilter: new FormControl(''),
    adqFilter: new FormControl(''),
    idProvFilter: new FormControl(0),
    idAdqFilter: new FormControl(0)
  });

  ImportePendiente:any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  loading: boolean;
  displayedColumns: string[] =
    ['checked', 'Fecha', 'RazonSocialAdquirente','RazonSocialProveedor', 'Moneda', 'Cuenta', 'Banco', 'Tipo_Pago', 'Deposito_Importe','ImportePendiente', 'Deposito_a_Aplicar', 'CodigoDeposito', 'Estado'];
  dataSource: any;
  user: any;
  form: FormGroup;
  recievedData: any = [];
  abrirDetalleCobranza: boolean;
  bancofilter = new FormControl('');
  filterValues = {
    Estado: '',
    Banco: '',
    Moneda: '',
    Tipo_Pago: '',
    From: '',
    To: ''
  };

  constructor(private datepipe: DatePipe, private cobranzasService: CobranzasService, private datePipe: DatePipe, private router: Router) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive')); 
    this.displayedColumns = (this.user.id_roles == 45)? ['Fecha', 'RazonSocialAdquirente','RazonSocialProveedor', 'Moneda', 'Cuenta', 'Banco', 'Tipo_Pago', 'Deposito_Importe','ImportePendiente', 'Deposito_a_Aplicar', 'CodigoDeposito', 'Estado']:this.displayedColumns;
    
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();    
  }

  ngOnInit() {
    this.DTOFiltrosCobranza.TipoMoneda = 0;
    this.DTOFiltrosCobranza.TipoBanco = 0;
    this.DTOFiltrosCobranza.TipoPago = 0;

    this.dataFiltro.get('Banco').valueChanges.subscribe(
      Banco => {
        this.filterValues.Banco = Banco;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.dataFiltro.get('Moneda').valueChanges.subscribe(
      Moneda => {
        this.filterValues.Moneda = Moneda;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.dataFiltro.get('Tipo_Pago').valueChanges.subscribe(
      Tipo_Pago => {
        this.filterValues.Tipo_Pago = Tipo_Pago;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.dataFiltro.get('Estado').valueChanges.subscribe(
      estado => {
        this.filterValues.Estado = estado;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    
    this.dataFiltro.get('fromDate').valueChanges.subscribe(
      from => {
        this.filterValues.From = (from === null ? "" : this.datePipe.transform(from,'yyyy-MM-dd'));
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
    
    this.dataFiltro.get('toDate').valueChanges.subscribe(
      to => {
        this.filterValues.To = (to === null ? "" : this.datePipe.transform(to,'yyyy-MM-dd')); 
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );

    this.ListadoCobranzaFiltros()
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.Estado.toString().toUpperCase().indexOf(searchTerms.Estado) !== -1
        && data.Banco.toString().toUpperCase().indexOf(searchTerms.Banco) !== -1
        && data.Moneda.toString().toUpperCase().indexOf(searchTerms.Moneda) !== -1
        && data.Tipo_Pago.toString().toUpperCase().indexOf(searchTerms.Tipo_Pago) !== -1
        && data.Fecha >= (searchTerms.From == "" ? data.Fecha : searchTerms.From)
        && data.Fecha <= (searchTerms.To == "" ? data.Fecha : searchTerms.To)
    }
  }

  tipoMoneda(event) {
    this.dataFiltro.controls["Moneda"].setValue(event)
    if (event == '') {
      this.DTOFiltrosCobranza.TipoMoneda = 0;
    } else {
      this.DTOFiltrosCobranza.TipoMoneda = event;
    }
  }
  banco(event) {
    this.dataFiltro.controls["Banco"].setValue(event)
    if (event == '') {
      this.DTOFiltrosCobranza.TipoBanco = 0;
    } else {
      this.DTOFiltrosCobranza.TipoBanco = event;
    }
  }
  tipoPago(event) {
    this.dataFiltro.controls["Tipo_Pago"].setValue(event)
    if (event == '') {
      this.DTOFiltrosCobranza.TipoPago = 0;
    } else {
      this.DTOFiltrosCobranza.TipoPago = event;
    }
  }
  ListadoCobranzaFiltros() {
    if (this.dataFiltro.controls['fromDate'].value == "" || !this.dataFiltro.controls['fromDate'].value) {
      this.DTOFiltrosCobranza.FechaInicio = "19900101";
    } else {
      this.DTOFiltrosCobranza.FechaInicio = this.datePipe.transform(this.dataFiltro.controls['fromDate'].value, 'yyyy-MM-dd');
    }
    if (this.dataFiltro.controls['toDate'].value == "" || !this.dataFiltro.controls['toDate'].value) {
      this.DTOFiltrosCobranza.FechaFin = "19900101";
    } else {
      this.DTOFiltrosCobranza.FechaFin = this.datePipe.transform(this.dataFiltro.controls['toDate'].value, 'yyyy-MM-dd');
    }
    this.DTOFiltrosCobranza.Estado = this.dataFiltro.controls['Estado'].value
    this.DTOFiltrosCobranza.Proveedor = this.dataFiltro.controls['idProvFilter'].value
    this.DTOFiltrosCobranza.Adquirente = this.dataFiltro.controls['idAdqFilter'].value
    console.log(this.DTOFiltrosCobranza);
    this.loading = true;
    this.cobranzasService.FiltroListadoCobranza(this.DTOFiltrosCobranza)
      .subscribe(
        res => {
          this.Cobranza = res;
          console.log(this.Cobranza);
          this.dataSource = new MatTableDataSource(this.Cobranza);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.dataSource.filterPredicate = this.createFilter();
          this.loading = false;
        }, err => {
          Swal.fire({
            title: "¡Algo salió mal!",
            text: err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        }
      )
  }

  

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.dataFiltro.get('provFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterProv(state) : this.proveedoresArr.slice())
    );   
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }
  

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.dataFiltro.get('adqFilter').valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterAdq(state) : this.adquirentessArr.slice())
    ); 
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true ||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }
  
  obtenerRucRazSocialAdq(termino: string = ''){
    if (termino != null && termino != ''){          
      termino = termino.toLowerCase();                
      for(let p of this.adquirentessArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
          let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.dataFiltro.get('idAdqFilter').setValue(p.idEmpresa);
          this.dataFiltro.get('adqFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.dataFiltro.get('idAdqFilter').setValue(0);
      this.dataFiltro.get('adqFilter').setValue('');
    }
  }

  obtenerProvId(){
    this.dataFiltro.controls["idProvFilter"].setValue(0);
  }

  obtenerAdqId(){
    this.dataFiltro.controls["idAdqFilter"].setValue(0);
  }
  obtenerRucRazSocialProv(termino: string = ''){
    if (termino != null && termino != ''){
      termino = termino.toLowerCase();                  
      for(let p of this.proveedoresArr){
        let raz = p.Razon_Social.toLocaleLowerCase();
        let ruc = p.Num_Doc_Identificacion;
        if (raz.indexOf(termino) >= 0 || ruc.indexOf(termino) >= 0){
          this.dataFiltro.get('idProvFilter').setValue(p.idEmpresa);
          this.dataFiltro.get('provFilter').setValue(p.Razon_Social);
          break;
        }
      }
    } else {
      this.dataFiltro.get('idProvFilter').setValue(0);
      this.dataFiltro.get('provFilter').setValue('');
    }
  }

  abrir(element: any) {
    this.cobranzasService.dataCobranza = element;
    this.abrirDetalleCobranza = true;
  }
  CerrarDetalle() {
    this.abrirDetalleCobranza = false;
  }

  BajaCobranza(idCobranza) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja la Cobranza ' + idCobranza + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si,dar de baja.',
      cancelButtonText: 'No,Cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        this.form = new FormGroup({
          'idCobranza': new FormControl(idCobranza),
          'Estado': new FormControl('B'),
          'Baja_Usuario': new FormControl(this.user.Usuario),
          'Baja_Canal': new FormControl('W')
        })
        this.cobranzasService.bajaCobranza(this.form.value)
          .subscribe(
            res => {
              Swal.fire({
                title: 'Éxito',
                text: 'La cobranza fue dada de baja exitosamente.',
                type: 'success',
                heightAuto: false
              }).then(resp =>{
                if(resp.value == true){
                  this.ListadoCobranzaFiltros();
                }
              });
            },
            err => {
              Swal.fire({
                title: "Error",
                text: "No se pudo dar de baja la cobranza.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            }
          )
      }
    })
  }

}
